import { NgModule } from '@angular/core';
import { TradePricingMaskDirective } from './trade-pricing-mask.directive';
import { TradePricingService } from './trade-pricing.service';

@NgModule({
    imports: [TradePricingMaskDirective],
    exports: [TradePricingMaskDirective]
})
export class TradePricingModule {
    constructor(tradePricingService: TradePricingService) {}
}
